import ListMenuItem from "@/app/components/menu/listMenuItem";
import { OverlayMenuBaseProps } from "@/app/components/menu/overlayMenuSystem";
import style from "@/app/components/menu/overlayMenuSystem.module.scss";

export default function SupportMenuFAQ({}: OverlayMenuBaseProps) {
  return (
    <div className={`${style.overlayMenuContainer} ${style.faqMenu}`}>
      <div className={style.menuListItemContainer}>
        <ListMenuItem
          id="support-faq-how-track-order"
          linkTo="https://support.net32.com/hc/en-us/articles/28137253964179-How-can-I-track-my-order"
        >
          How to Track an Order
        </ListMenuItem>
        <ListMenuItem
          id="support-faq-how-change-order"
          linkTo="https://support.net32.com/hc/en-us/articles/28137172636307-How-can-I-cancel-an-order"
        >
          How to Cancel an Order
        </ListMenuItem>
        <ListMenuItem
          id="support-faq-how-return-order"
          linkTo="https://support.net32.com/hc/en-us/articles/28137009506579-How-can-I-submit-a-return-request"
        >
          How to Return an Order
        </ListMenuItem>
        <ListMenuItem
          id="support-faq-shipping-policy"
          linkTo="https://support.net32.com/hc/en-us/articles/41919340147987-How-Does-Shipping-Work-on-Net32"
        >
          Shipping Policy
        </ListMenuItem>
        <ListMenuItem
          id="support-faq-return-policy"
          linkTo="https://support.net32.com/hc/en-us/articles/28136939501203-Is-my-product-eligible-for-a-return"
        >
          Return Policy
        </ListMenuItem>
        <ListMenuItem id="support-faq-help-center" linkTo="https://support.net32.com/hc/en-us">
          Help Center
        </ListMenuItem>
      </div>
    </div>
  );
}
